import { HttpParams } from '@angular/common/http'
import { UUID } from '../../app/common/components/types/uuid'
import { BaseWithId, PaginatedList, PaginatedSearchCriteria } from './base.model'

export class Employee extends BaseWithId {
    firstName: string
    lastName: string
    atlassianAccountId: UUID

    static fromJSON(json: any): Employee {
        return new Employee(json.id, json.persistenceVersion, json.firstName, json.lastName, json.atlassianAccountId)
    }

    static get fullNameCompareFn(): (a: Employee, b: Employee) => number {
        return (a, b) => a.fullName.localeCompare(b.fullName)
    }
    get fullName(): string {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`
        }
        if (this.atlassianAccountId) {
            return this.atlassianAccountId
        }

        return ''
    }

    constructor(id: number, persistenceVersion: number, firstName: string, lastName: string, atlassianAccountId: UUID) {
        super()
        this.firstName = firstName
        this.lastName = lastName
        this.id = id
        this.persistenceVersion = persistenceVersion
        this.atlassianAccountId = atlassianAccountId
    }
}

export class EmployeeSearchCriteria extends PaginatedSearchCriteria {
    atlassianAccountId?: UUID
    includeArchived?: boolean

    constructor(page?: number, pageSize?: number, atlassianAccountId?: UUID, includeArchived?: boolean) {
        super(page, pageSize)
        this.atlassianAccountId = atlassianAccountId
        this.includeArchived = includeArchived
    }

    httpParams(): HttpParams {
        let params = super.httpParams()

        if (this.atlassianAccountId) {
            params = params.set('atlassianAccountId', this.atlassianAccountId)
        }

        if (this.includeArchived) {
            params = params.set('includeArchived', `${this.includeArchived}`)
        }

        return params
    }
}

export class EmployeePaginatedList extends PaginatedList<Employee> {
    static fromJSON(json: any): EmployeePaginatedList {
        const result: EmployeePaginatedList = Object.create(EmployeePaginatedList.prototype)

        return {
            ...result,
            ...json,
            items: json.items ? json.items.map((item: any) => Employee.fromJSON(item)) : null
        }
    }
}
